import { SxProps, Theme } from '@mui/material';

export const addProductCartSX: Record<string, SxProps> = {
	addButton: {
		height: '40px',
	},
	prompAlert: {},
};

export const prompAlert = (theme: Theme) => ({
	display: 'flex',
	backgroundColor: theme.palette.warning.light,
	color: theme.palette.warning.main,
	border: `solid 1px ${theme.palette.warning.main}`,
	marginBottom: theme.spacing(1),
	padding: '5px',
	'& svg': {
		fontSize: '10px',
		marginTop: '2px',
		marginRight: '3px',
		color: theme.palette.warning.main,
	},
});
